import { useCallback } from 'react';
import { useGetIdentity } from 'react-admin';
import { supabase } from '../providers/supabase/supabase';

export type BindTimesCsvRow = {
    AIP?: string;
    aip?: string;
    States?: string;
    states?: string;
    State?: string;
    state?: string;
    'Bind Time'?: string;
    bind_time?: string;
    Bind_Time?: string;
};

function normalizeRow(raw: BindTimesCsvRow) {
    const aip = (raw.AIP ?? raw.aip ?? '').toString().trim();
    const states = (raw.States ?? raw.states ?? raw.State ?? raw.state ?? '')
        .toString()
        .trim();
    const bind_time = (raw['Bind Time'] ?? raw.bind_time ?? raw.Bind_Time ?? '')
        .toString()
        .trim();

    return { aip, states, bind_time };
}

export function useBindTimesImport() {
    const user = useGetIdentity();

    const processBatch = useCallback(
        async (batch: BindTimesCsvRow[]) => {
            const rows = batch.map(normalizeRow).filter(r => r.aip && r.states);

            if (rows.length === 0) return;

            const { error } = await supabase.from('bind_times').insert(rows);

            if (error) {
                console.error('Bind times import batch error:', error);
                throw error;
            }
        },
        [user?.identity?.id]
    );

    return { processBatch };
}
